import TravellerChangeWarningModalHandler from './travellerChangeWarningModalHandler';
import { changeTravellerAction } from './oneFrontActions';
export const travellerChangeWarningModalProps = {
  listenTravellerChanges: TravellerChangeWarningModalHandler.listen,
  stopListenTravellerChanges: TravellerChangeWarningModalHandler.stopListening
};
export const traveller = changeTravellerAction;